module.exports = __webpack_public_path__ + "img/swiper_05.54544b51.jpg";